import { ENV, authFetch, parseResponse, SUCCESSARRAY } from "../utils";

function cleanFilters(filters = {}) {
  return Object.fromEntries(
    Object.entries(filters).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );
}

export class Store {
  async getCategories() {
    const url = `${ENV.API_URL}/${ENV.ENDPOINTS.STORE.CATEGORIES}`;

    const response = await authFetch(url);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async getProducts(page = 1, limit = 12, filters = {}) {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      ...cleanFilters(filters),
    });

    const url =
      `${ENV.API_URL}/${ENV.ENDPOINTS.STORE.PRODUCTS}?${queryParams.toString()}`;

    const response = await authFetch(url);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async getProduct(slug) {
    const url = `${ENV.API_URL}/${ENV.ENDPOINTS.STORE.PRODUCT}/${slug}`;

    const response = await authFetch(url);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async getFilters(filters = {}) {
    const queryParams = new URLSearchParams(cleanFilters(filters));

    const url =
      `${ENV.API_URL}/${ENV.ENDPOINTS.STORE.FILTERS}?${queryParams.toString()}`;

    const response = await authFetch(url);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async getSettings() {
    const url = `${ENV.API_URL}/${ENV.ENDPOINTS.STORE.SETTINGS}`;

    const response = await authFetch(url);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }
}
